/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteVideoEditorProjectsProjectMutationResponse, DeleteVideoEditorProjectsProjectPathParams } from "../models/DeleteVideoEditorProjectsProject";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteVideoEditorProjectsProject } from "../axios/deleteVideoEditorProjectsProject";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteVideoEditorProjectsProjectMutationKey = () => ["web-app-bff-api", { url: '/video-editor/projects/:id' }] as const

export type DeleteVideoEditorProjectsProjectMutationKey = ReturnType<typeof deleteVideoEditorProjectsProjectMutationKey>

export function deleteVideoEditorProjectsProjectMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteVideoEditorProjectsProjectMutationKey()
        return mutationOptions<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorProjectsProjectPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteVideoEditorProjectsProject(id, config)
          },
        })

}

/**
 * @summary Delete a project
 * {@link /video-editor/projects/:id}
 */
export function useDeleteVideoEditorProjectsProject<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorProjectsProjectPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteVideoEditorProjectsProjectMutationKey()

          const baseOptions = deleteVideoEditorProjectsProjectMutationOptions(config) as UseMutationOptions<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorProjectsProjectPathParams["id"]}, TContext>
          

          return useMutation<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorProjectsProjectPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteVideoEditorProjectsProjectMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorProjectsProjectPathParams["id"]}, TContext>
      
}